export enum LocalStorageKeys {
  SEARCH_METHOD = 'SEMANTIC_SEARCH_METHOD',
  SEARCH_PHRASE = 'SEMANTIC_SEARCH_PHRASE',
}
